export const CONTACT_PUSH_STATUS = 'CONTACT_PUSH_STATUS'
